module.exports = __webpack_public_path__ + "static/img/class_sm_6.c7d8ecad.jpg";